import React, {useEffect, useRef, useState} from 'react';
import {Dialog, DialogActions, DialogContent} from '@mui/material';
import {Button} from '@finpay-development/shared-components';
// @ts-ignore
import { Document, Page, pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface ModalProps {
  isOpen: boolean;
  handleModalCancel: () => void;
  pdfBlob: Blob
}

export function AuthDocPdfModal(props: ModalProps) {

  const {isOpen, handleModalCancel, pdfBlob} = props;
  const [numPages, setNumPages] = useState(null);
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        const newWidth = entry.contentRect.width
        if(newWidth > 0){
          setWidth(entry.contentRect.width);
        }
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [containerRef.current]);

  return (
      <Dialog
          scroll="paper"
          open={isOpen}
          maxWidth="md"
          PaperProps={{
            sx: {
              maxHeight: '80vh',
              overflow: 'auto',
              ... window.innerWidth < 960 && {
                width: `100%`,
                margin:'1rem',
                display: 'flex',
                alignItems: 'center',
              }
            },
          }}
          ref={containerRef}
          test-id="auth-doc-pdf-modal"
      >
        <DialogContent
            sx={{
              overflow: 'unset',
            }}
        >

          <Document

              file={pdfBlob}
              onLoadSuccess={({ numPages }: any) => setNumPages(numPages)}
              loading="Loading PDF..."
          >
            {Array.from(new Array(numPages), (el, index) => (
                <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    {...( window.innerWidth < 960) && {width : width*0.95}
                }

                />
            ))}
          </Document>
        </DialogContent>

        <DialogActions style={{borderTop: '', marginTop: '0', padding: '2rem'}}>
          <Button test-id="auth-doc-modal-close-btn"
                  onClick={handleModalCancel}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
  );
}